import { createFileRoute, redirect, stripSearchParams } from "@tanstack/react-router";
import { dashboardAnalyticsQuery } from "@/api/queries/dashboard";
import type { DashboardRange } from "@/api/types";
import { DashboardAnalyticsPage } from "@/pages/dashboard/AnalyticsPage";
import { AnalyticsSkeleton } from "@/pages/dashboard/AnalyticsSkeleton";

const RANGES = ["7d", "30d", "90d"] as const;
type AnalyticsSearch = { range: DashboardRange };

function validateSearch(search: Record<string, unknown>): AnalyticsSearch {
  const range = typeof search.range === "string" && RANGES.includes(search.range as DashboardRange)
    ? (search.range as DashboardRange)
    : "30d";
  return { range };
}

export const Route = createFileRoute("/dashboard/analytics")({
  // Mock data, hidden for real stores until analytics are real (docs/plans/marketplace-commerce.md M3, M7).
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
  validateSearch,
  search: { middlewares: [stripSearchParams<AnalyticsSearch>({ range: "30d" })] },
  loaderDeps: ({ search }) => ({ range: search.range }),
  loader: ({ context, deps }) => {
    const range = deps.range;
    void context.queryClient.prefetchQuery(dashboardAnalyticsQuery("7d"));
    void context.queryClient.prefetchQuery(dashboardAnalyticsQuery("30d"));
    void context.queryClient.prefetchQuery(dashboardAnalyticsQuery("90d"));
    return context.queryClient.prefetchQuery(dashboardAnalyticsQuery(range));
  },
  pendingComponent: AnalyticsSkeleton,
  component: DashboardAnalyticsPage,
});
